<template>
    <div class="remote-consultation clearfix">
        <div class="remote-consultation-wrap marginP">
            <div class="search-content-bar" style="height:100px;">
                <label class="searchTip">患者姓名</label>
                <input v-model="consulterName" type="search" style="width:100px;" class="search-content-input"/>
                <label class="searchTip" style="margin-left:20px;">申请机构</label>
                <el-select v-model="initHosId"
                           placeholder="请选择医院"
                           @visible-change="getHospList"
                           @change="getHospId"
                           size="small">
                    <el-option v-for="item in hospList" :label="item.hosName" :value="item.hosId" :key="item.hosId"/>
                </el-select>
                <label class="searchTip" style="margin-left:20px;">会诊机构</label>
                <el-select
                        v-model="acceptHosId"
                        placeholder="请选择医院"
                        size="small"
                        @visible-change="getHospLists"
                        @change="getHospIds">
                    <el-option v-for="item in hospLists" :label="item.hosName" :value="item.hosId" :key="item.hosId"/>
                </el-select>
                <br>
                <label class="searchTip">安排会诊时间</label>
                <el-date-picker
                        v-model="startTime"
                        type="date"
                        placeholder="选择日期"
                        size="small"
                        :picker-options="pickerOptions0">
                </el-date-picker>
                到
                <el-date-picker
                        v-model="endTime"
                        type="date"
                        placeholder="选择日期"
                        size="small"
                        :picker-options="pickerOptions0">
                </el-date-picker>
                <!--<label class="searchTip" style="margin-left:20px;">快速搜索</label>-->
                <!--<input v-model="searchKey" type="search" class="search-content-input"/>-->
                <el-button size="small" style="margin-left:30px;" type="primary" class="search-btn btn" @click="searchHandler">
                    查询
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="linkDocToAss"
                        class="sponsored-btn btn">
                    发起会诊
                </el-button>
            </div>
            <div class="tabLine" style="border: 1px solid #E5E5E5;">
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_dcl" class="badge-1 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_clz" class="badge-2 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_dhz" class="badge-3 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_ywc" class="badge-4 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_yqx" class="badge-5 tab-badge"/>
                <el-tabs @tab-click="changeTab" v-model="activeName" class="tabRow">
                    <el-tab-pane label="待处理" name="toDeal" />
                    <el-tab-pane label="处理中(我的)" name="toTreat"/>
                    <el-tab-pane label="待会诊" name="toVideo"/>
                    <el-tab-pane label="已完成" name="finished"/>
                    <el-tab-pane label="已取消" name="cancelled"/>
                </el-tabs>
            </div>
            <!--各标签列表内容-->
            <div class="tabLine-content">
                <!--待处理标签内容-->
                <div v-show="activeName == 'toDeal' ">
                    <RemoteConsultationTableCmp1 :propsTableData="contentData1" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage1" :propsPageSize="7"/>
                </div>
                <!--处理中标签内容-->
                <div v-show="activeName == 'toTreat' ">
                    <RemoteConsultationTableCmp2 :propsTableData="contentData2" tableType="ychz_clz" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage2" :propsPageSize="7"/>
                </div>
                <!--待会诊标签内容-->
                <div v-show="activeName == 'toVideo' ">
                    <!--可用contentDataArr2代替3 两个内容一致-->
                    <RemoteConsultationTableCmp2 :propsTableData="contentData3" tableType="ychz_dhz" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage3" :propsPageSize="7"/>
                </div>
                <!--已结束标签内容-->
                <div v-show="activeName == 'finished' ">
                    <RemoteConsultationTableCmp4 :propsTableData="contentData4" tableType="ychz_ywc" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage4" :propsPageSize="7"/>
                </div>
                <div v-show="activeName == 'cancelled' ">
                    <RemoteConsultationTableCmp4 :propsTableData="contentData4" tableType="ychz_yqx" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage4" :propsPageSize="7"/>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import { Badge, Button,Input,Tabs,TabPane, Loading, Message} from "element-ui";
    import axiosUtil from "../../utils/AxiosUtils.js";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import RemoteConsultationTableCmp1 from "./RemoteConsultationTableCmp1.vue";
    import RemoteConsultationTableCmp2 from "./RemoteConsultationTableCmp2.vue";
    //import RemoteConsultationTableCmp3 from "./RemoteConsultationTableCmp3.vue";
    import RemoteConsultationTableCmp4 from "./RemoteConsultationTableCmp4.vue";
    import {upLoadBasicParam} from "../../data/basicParam.js";
    import FooterCmp from "../common/FooterCmp.vue";
    import Vue from "vue";
    Vue.use(Badge);
    Vue.use(Button);
    Vue.use(Input);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Loading);
    export default{
        data: function(){
            return {
                activeName: "toDeal",//切换标签的值
                searchKey: "",// 搜索内容
                propsTotalCols: 0,//列表总数量
                contentData1: [],
                initHosId:'',//发起医院
                acceptHosId:'',//接受医院
                startTime:'',//开始时间
                endTime:'',//结束时间
                consulterName:'',//患者姓名
                contentData2: [],
                time1:'',
                time2:'',
                hospList:[],
                hospLists:[],
                contentData3: [],
                contentData4: [],
                /*currentPage1: 1,//列表1当前页数
                currentPage2: 1,//列表2当前页数
                currentPage3: 1,//列表3当前页数
                currentPage4: 1,//列表4当前页数*/
                isSuccess: false,//是否加载成功
            }
        },
        created: function(){
            this.getData( "",["2"], "waitGrab", "contentData1","","","","","", 1);
            this.$store.dispatch("isGetNewMsg_ychz_dcl", false);// 清除小红点
            this.$store.dispatch("changeSideItem", "ychz");//侧边栏高亮 消除侧边栏
        },
        components:{
            RemoteConsultationTableCmp1,
            RemoteConsultationTableCmp2,
            //RemoteConsultationTableCmp3,
            RemoteConsultationTableCmp4,
            FooterCmp
        },
        computed: {
            /*contentDataArr1: function(){//把总数据中的7个数据传递个列表组件显示
                return this.splitDataArr(this.contentData1, this.currentPage1, 7);
            },
            contentDataArr2: function(){
                return this.splitDataArr(this.contentData2, this.currentPage2, 7);
            },
            contentDataArr3: function(){
                return this.splitDataArr(this.contentData3, this.currentPage3, 7);
            },
            contentDataArr4: function(){
                return this.splitDataArr(this.contentData4, this.currentPage4, 7);
            },*/
            isGetNewMsg_ychz_dcl: function() {// 待处理
                return this.$store.state.isGetNewMsg_ychz_dcl;
            },
            // isGetNewMsg_ychz_clz: function() {// 处理中
            //     return this.$store.state.isGetNewMsg_ychz_clz;
            // },
            isGetNewMsg_ychz_dhz: function() {// 待会诊
                return this.$store.state.isGetNewMsg_ychz_dhz;
            },
            isGetNewMsg_ychz_ywc: function() {// 已完成
                return this.$store.state.isGetNewMsg_ychz_ywc;
            },
            isGetNewMsg_ychz_yqx: function() {// 已取消
                return this.$store.state.isGetNewMsg_ychz_yqx;
            },
        },
        methods: {
            getData: function(consulterName="", statusList, subStatus="", contentDataType=[], searchKey="",endTime="",startTime="",acceptHosId="",initHosId="", pageNo=1, sort="modify_time.desc"){//使用axios获取数据 函数封装避免重复代码
                let _this=this;
                startTime=formatUnixTime(startTime)?formatUnixTime(startTime):'';
                endTime=formatUnixTime(endTime)?formatUnixTime(endTime):'';
                let options = {
                    aspectUser: "accept",
                    statusList: statusList,
                    subStatus: subStatus,
                    searchKey: searchKey,
                    startTime:startTime,
                    endTime:endTime,
                    acceptHosId:acceptHosId,
                    consulterName:consulterName,
                    initHosId:initHosId,
                    pageNo: pageNo,
                    pageSize: 7,
                    sort: sort,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.list"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.propsTotalCols = data.paginator.totalCount;
                    //_this.$store.dispatch("getCurrentConsultList", data.list);
                    switch (contentDataType){//根据切换的标签获取不同数据
                        case "contentData1":
                            _this.contentData1 = data.list;
                            break;
                        case "contentData2":
                            _this.contentData2 = data.list;
                            break;
                        case "contentData3":
                            _this.contentData3 = data.list;
                            break;
                        case "contentData4":
                            _this.contentData4 = data.list;
                            break;
                        default:
                            _this.contentData1 = data.list;
                            break;
                    }
                }, function () {
                    _this.isSuccess = true;
                });
            },
            getTabList: function(tabName, searchKey="",pageNo=1,consulterName="",endTime="",startTime="",initHosId="",acceptHosId="", ) {// 获取列表
                this.isSuccess = false;
                switch(tabName){
                    case "toDeal"://待处理
                        this.$store.dispatch("isGetNewMsg_ychz_dcl", false);// 清除小红点
                        this.getData(consulterName,["2"], "waitGrab", "contentData1", searchKey,endTime,startTime,acceptHosId,initHosId, pageNo);
                        break;
                    case "toTreat"://我发起的
                        this.$store.dispatch("isGetNewMsg_ychz_clz", false);// 清除小红点
                        this.getData(consulterName,["2"], "waitDoc", "contentData2", searchKey,endTime,startTime,acceptHosId,initHosId, pageNo);
                        break;
                    case "toVideo"://待会诊
                        this.$store.dispatch("isGetNewMsg_ychz_dhz", false);// 清除小红点
                        this.getData(consulterName,["2"], "waitVideo", "contentData3", searchKey,endTime,startTime,acceptHosId,initHosId, pageNo);
                        break;
                    case "finished"://已结束/已取消
                        this.$store.dispatch("isGetNewMsg_ychz_ywc", false);// 清除小红点
                        this.getData(consulterName,["4", "6"], "", "contentData4", searchKey,endTime,startTime,acceptHosId,initHosId, pageNo);
                        break;
                    case "cancelled"://已结束/已取消
                        this.$store.dispatch("isGetNewMsg_ychz_yqx", false);// 清除小红点
                        this.getData(consulterName,["-1"], "", "contentData4", searchKey,endTime,startTime,acceptHosId,initHosId, pageNo);
                        break;
                    default:
                        this.$store.dispatch("isGetNewMsg_ychz_dcl", false);// 清除小红点
                        this.getData(["2"], "waitGrab", "contentData1", searchKey, pageNo);
                        break;
                }
            },
            changeTab: function(tab){//标签切换
                this.searchKey = "";
                this.getTabList(tab.name, this.searchKey, 1);
                this.activeName = tab.name;
            },
            changePage1: function(pageNo){//各个标签改变页数
                this.getTabList(this.activeName, this.searchKey, pageNo,this.consulterName,this.endTime,this.startTime,this.initHosId,this.acceptHosId );
            },
            changePage2: function(pageNo){
                this.getTabList(this.activeName, this.searchKey, pageNo,this.consulterName,this.endTime,this.startTime,this.initHosId,this.acceptHosId );
            },
            changePage3: function(pageNo){
                this.getTabList(this.activeName, this.searchKey, pageNo,this.consulterName,this.endTime,this.startTime,this.initHosId,this.acceptHosId );
            },
            changePage4: function(pageNo){
                this.getTabList(this.activeName, this.searchKey, pageNo,this.consulterName,this.endTime,this.startTime,this.initHosId,this.acceptHosId );
            },
            linkDocToAss: function () {//发起医助医会诊
                this.$store.dispatch("getConsultType", "ASS");
                this.$router.push("remoteConsultation/launch");
            },
            linkDoc: function () {//发起医医会诊
                this.$store.dispatch("getConsultType", "DOC");
                this.$router.push("remoteConsultation/launch");
            },
            launchConsul: function(){//跳转到发起会诊页面
                this.$router.push("remoteConsultation/launch");
            },
            searchHandler: function(){// 搜索内容
                this.getTabList(this.activeName, this.searchKey,1,this.consulterName,this.endTime,this.startTime,this.initHosId,this.acceptHosId );
            },
            getHospList: function(showList){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                if(showList){//当点击出现下拉菜单时 获取列表
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospList = data.list;
                    });
                }
            },
            getHospId: function(hospId){//获取选择的医院id
                this.hopeHosId = hospId;
                this.hopeDeptId = "";// 清空已经选择的科室和医生
                this.hopeDocId = "";
            },
            getHospLists: function(showList){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                if(showList){//当点击出现下拉菜单时 获取列表
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospLists = data.list;
                    });
                }
            },
            getHospIds: function(hospId){//获取选择的医院id
                this.hopeHosId = hospId;
                this.hopeDeptId = "";// 清空已经选择的科室和医生
                this.hopeDocId = "";
            },
        }
    }
</script>
